const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/admin/surveys/$surveyId/edit.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_authenticated/_feature_announcement/admin/surveys/$surveyId/edit")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});